// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qf-0";